import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { TranslateService } from '@ngx-translate/core';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { ApiService } from '../api.service';
import { url } from 'inspector';

@Component({
  selector: 'app-admin-reg',
  templateUrl: './admin-reg.component.html',
  styleUrls: ['./admin-reg.component.scss'],
})
export class AdminRegComponent {

  constructor(public router: Router,
              private bottomSheet: MatBottomSheet,
              public translate: TranslateService,
              public handler: HandlerService,
              public service: ApiService,
              public auth: AuthService) { }

  pass; hide; numCd = "+91"; numb; fName; lName; email; org; loader = false;
  header; img;mail:boolean= true;verified;url;
  passwordPolicy:boolean=false;
  fontStyle;roles;code;y;url1;
  adproofName;
  proofObj:any;
  addsProof;
  idProofName;
  proofId;
  userObj:any=[];
  aproofId;
  pic: any;
  pic1: any;
  id;
  empReg:boolean=false;
  catArray:any=[]
  ionViewWillEnter() {
    this.empReg = false;
    this.id=sessionStorage.getItem('newId')
    this.fontStyle = localStorage.getItem('lang');  
    this.url1 = window.location.href;  
    this.url = window.location.href;  
    var y = JSON.parse(sessionStorage.getItem('category'));
    y.map(res=>{
      this.catArray.push(res.id)
    })
    if(this.url.includes('employeeReg')){
  
      this.empReg = true;
    this.service.getAddressById(this.id).subscribe((res:any) => {
      console.log(res)
      this.userObj = res;
      this.numb=res.contactNbrMob.slice(3);
      this.idProof();
      this.AddressProof();
        })
      }
    if (this.url1.includes('admin')) {
      this.header= "ADMIN REGISTRATION";
      this.roles=['SP'];
   
     }
     else if(this.url1.includes('vendorEmpReg')){
       this.mail=false;
      this.header= "EMPLOYEE REGISTRATION";   
      this.org=  sessionStorage.getItem("orgCd");
      this.roles=['SC'];
     }
     else if(this.url1.includes('mangerEmpReg')){
      this.mail=false;
     this.header= "MANAGER REGISTRATION";   
     this.org=  sessionStorage.getItem("orgCd");
     this.roles=['VM'];
    } 
    else if(this.url1.includes('custReqEmpReg')){
      this.mail=false;
     this.header= "REQUEST HANDLER REGISTRATION";   
     this.org=  sessionStorage.getItem("orgCd");
     this.roles=['CUSTRQH'];
    } 
    else if(this.url1.includes('custCareEmpReg')){
      this.mail=false;
     this.header= "CUSTOMERCARE REGISTRATION";   
     this.org=  sessionStorage.getItem("orgCd");
     this.roles=['CUSTSUP'];
    } 
     else if(this.url1.includes('supervisorReg')){
      this.mail=false;
     this.header= "SUPERVISOR REGISTRATION";
    //  var x = JSON.parse(localStorage.getItem('capabilityOrg'));
     this.org=  sessionStorage.getItem("orgCd");
    //  this.org=x[0].code;
     this.roles=['SPVR'];
    }else {
      this.mail=false;
     this.header= "EMPLOYEE REGISTRATION";
     this.org="YB";
     this.roles=['SC'];
    }
  }


  checkMob(event) {
    event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    this.numb = event.target.value;
  }

  action(){
    if(this.url.includes('employeeReg')){
    this.UpdateProfile();
  }else{
    this.register();
  }

  }

  register() {  
     this.loader = true;
    if (!this.loader && this.fName && this.lName && this.numb  && this.email)
    if(this.fName){
      this.fName = this.fName.toUpperCase();
    }
    if(this.lName){
      this.lName = this.lName.toUpperCase();
    }
    if(this.org){
      this.org = this.org.toUpperCase();
    }
      var post = {     
        contactNbrMob: this.numCd + this.numb,
        firstName: this.fName,
        lastName: this.lName,
        category:this.catArray,     
        userType: 1,
        verified:this.verified,
        orgCode: this.org,
        emailId: this.email,
        profilePic:this.pic,
        appId: 14,
        roles:this.roles
      }
      if(this.url1.includes('vendorEmpReg') || this.url1.includes('mangerEmpReg') || this.url1.includes('custReqEmpReg') || this.url1.includes('custCareEmpReg') ){
        Object.assign(post,{paless: true,verified:true,staffAdminInd:false})
      }else if(this.url1.includes('supervisorReg')){
        Object.assign(post,{paless: true,verified:true,staffAdminInd:false})
      }
      else if (this.url1.includes('admin')) {
        Object.assign(post,{password: window.btoa(this.pass),verified:true})
      }else {
        Object.assign(post,{password: window.btoa(this.pass),verified:false})
      }
    this.service.registerAdmin(post).subscribe(
      (res: any) => {
  
        if(this.url1.includes('admin')){
          window['mock'] = res;
          sessionStorage.setItem('contactNbrMob',this.numb)
          this.router.navigate(['/account-validate']);
        }
       if(this.url1.includes('vendorEmpReg')){
          localStorage.setItem('vendoruserId', res.userId);
          this.router.navigate(['/mngVendorAdd']); 
         }
          if(this.url1.includes('employeeReg')){
            window['mock'] = res;
          localStorage.setItem('vendoruserId', res.userId);
          // this.router.navigate(['/vendoraddress']);
          this.router.navigate(['/account-validate']) 
         } 
         if(this.url1.includes('supervisorReg') || this.url1.includes('mangerEmpReg') || this.url1.includes('custReqEmpReg') || this.url1.includes('custCareEmpReg') ){
        this.router.navigate(['/user']); 
         }      
      
        sessionStorage.clear()
        this.loader = false;
        this.handler.res('Registered Successfully !!')
      },
      err => {
        this.handler.err(err);
        this.loader = false;
      })
  
   
  }
  handleFile1(files) {
    if(files[0].size < 1048576){
      var img = new Image();
      img.src = URL.createObjectURL(files[0]);
      img.onload = (data)=>{
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0,0);  
        this.img = canvas.toDataURL('image/jpeg',0.07);
      }
    }
    else{
      this.handler.res('Image Size Should Not Exceeds 1mb ');
    }
}
openPasswordPolicy(){
    this.passwordPolicy=true;
}
closepwdpolicy(){
  this.passwordPolicy=false;
}
ionViewWillLeave(){ 
 this.numb ="";
 this.fName="";
 this.lName="";
 this.org="";
 this.email="";
 this.pic="";
 this.pass="";
 sessionStorage.clear();
}


idProof(){
  this.service.getIdProof().subscribe(res => { 
    this.proofObj = res;
  
  })
}

AddressProof(){
  this.service.getAddressProof().subscribe(res => { 
    this.addsProof = res;
   })
}


openBottomSheetAds(): void {    
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data:this.addsProof,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    if(res){
      this.adproofName = res.name;
    this.aproofId = res.id;
    }
  });
}


openBottomSheet(): void {
const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.proofObj,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    if(res){
      this.idProofName = res.name;
      this.proofId = res.id;
    }
  });
}

handleFile(files) {
  if(files[0].size < 1048576){
    var img = new Image();
    img.src = URL.createObjectURL(files[0]);
    img.onload = (data) => {
      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      this.pic = canvas.toDataURL('image/jpeg', 0.07);
    }
  }
  else{
    this.handler.res('Image Size Should Not Exceeds 1mb ');
  }
}



handleFile2(files) {
  if(files[0].size < 1048576){
  var img = new Image();
  img.src = URL.createObjectURL(files[0]);
  img.onload = (data) => {
    var canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    this.pic1 = canvas.toDataURL('image/jpeg', 0.07);
  }
}
else{
  this.handler.res('Image Size Should Not Exceeds 1mb ');
}
}

UpdateProfile(){
  if(this.proofId && this.aproofId){
     var x ={
       "userId": this.id,
       "proofId": this.proofId,
       "img" : this.pic
     }
     if(!this.userObj.userIdProof){
       Object.assign(this.userObj,{userIdProof:[]})
       this.userObj.userIdProof.push(x)
     }else{
       this.userObj.userIdProof[0]=x
     }
     var y ={
       "userId": this.id,
       "proofId": this.aproofId,
       "img" : this.pic1
     }
     if(!this.userObj.userAddressProof){
       Object.assign(this.userObj,{userAddressProof:[]})
       this.userObj.userAddressProof.push(y)
     }else{
       this.userObj.userAddressProof[0]=y
     }
     Object.assign(this.userObj,{verified:false,staffAdminInd:false})
     let catarray=[]
     let allcat=JSON.parse(sessionStorage.getItem('category'));
     if(!this.userObj.categories){
       Object.assign(this.userObj,{categories:[]})
       allcat.map(res=>{
        catarray.push({
          'userId':Number(this.id),
          'categoryId':res.id
        })
        })
       this.userObj.categories=catarray
     }else{
       catarray = this.userObj.categories;
       allcat.map(res=>{
        catarray.push({
          'userId':Number(this.id),
          'categoryId':res.id
        })
        })
      this.userObj.categories=catarray
     }
     this.userObj.firstName = this.fName;
     this.userObj.lastName = this.lName;
    this.userObj.orgCode= this.org,
           this.userObj.emailId= this.email,
           this.userObj.profilePic=this.pic,   
          //  this.userObj.Categories=this.catArray,
  console.log(this.userObj)
  this.service.postProfileDetails(this.id,this.userObj).subscribe(res=>{
 
   if(this.url.includes('employeeReg')){
   this.router.navigate(['map/',this.id])
   }

  }, err => {
   this.handler.err(err)
 })
}else{
  this.handler.staticError('Please enter required fields')
}
}

}
